<template>
  <div class="wrapper" :class="{'nav-open': $sidebar.showSidebar}">
    <notifications></notifications>
    <side-bar>
      <user-menu></user-menu>
 <!-- <mobile-menu></mobile-menu> -->
      <template slot-scope="props" slot="links">
        <sidebar-item :link="{name: 'Home', icon: 'fas fa-chart-pie', path: '/dashboard/home'}"/>
        <!-- <sidebar-item :link="{name: 'Payment Card', icon: 'fas fa-credit-card', path: '/dashboard/paymentCard'}"/> -->
        <sidebar-item :link="{name: 'Setup', icon: 'fas fa-cog', path: '/dashboard/setup'}"/>
      </template>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>

      <dashboard-content v-if="$store.getters.userStatus == 'active' || $route.path.includes('/setup')" @click.native="toggleSidebar"/>

      <div v-else class="m-4">
        <Welcome-Card class="col-11"/>
      </div>
      

      <!-- <content-footer></content-footer> -->
    </div>
  </div>
</template>
<script>
  import TopNavbar from './TopNavbar.vue'
  import ContentFooter from './ContentFooter.vue'
  import DashboardContent from './Content.vue'
  import MobileMenu from './Extra/MobileMenu.vue'
  import UserMenu from './Extra/UserMenu.vue'
  export default {
    components: {
      TopNavbar,
      ContentFooter,
      DashboardContent,
      MobileMenu,
      UserMenu
    },
    // beforeCreate () {
    //   this.$store.dispatch('fetchData')
    // },
    methods: {
      toggleSidebar () {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false)
        }
      }
    }
  }

</script>
